
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricMotorStep as ObiElectricMotorStepElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-motor-step.js';
 
 
 

 
 export const ObiElectricMotorStep = createComponent({
   react: React,
   tagName: 'obi-electric-motor-step',
   elementClass: ObiElectricMotorStepElement,
   events: {
     
   }
  });
 
 